import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';
import DonutChart from '@/components/charts/DonutChart.tsx';
import { breakdownToSlices } from '@/components/charts/breakdownAdapter.ts';
import NoItems from '@/components/ui/NoItems.tsx';
import { MoneyBreakdownDto } from '@/types/stats/BreakdownDto.ts';
import { getCurrencyLabel } from '@/features/dashboard/paymentConfig/types/Currency.utils.ts';
import { formatPrice } from '@/utils/formatters.ts';

interface CostCategoryDonutCardProps {
  /** `null`, gdy wyjazd nie ma jeszcze żadnego planu kosztów w żadnej walucie. */
  costs: MoneyBreakdownDto | null;
}

/** Udział kategorii w planie kosztów, jedna karta na walutę. */
const CostCategoryDonutCard = ({ costs }: CostCategoryDonutCardProps) => (
  <InfoCard>
    <InfoCardHeader title="Koszty po kategoriach">
      {costs && (
        <span className="mt-1 block text-[13px] text-neutral-400">
          w {getCurrencyLabel(costs.currency)}
        </span>
      )}
    </InfoCardHeader>

    <InfoCardBody>
      {!costs || costs.segments.length === 0 ? (
        <NoItems
          title="Brak planu kosztów"
          description="Zaplanuj wydatki, żeby zobaczyć, jak rozkładają się po kategoriach."
        />
      ) : (
        <>
          <DonutChart
            ariaLabel="Udział kategorii w planie kosztów"
            slices={breakdownToSlices(costs)}
          />

          <InfoCardRow label="Zaplanowane koszty razem" divided>
            <span className="text-[15px] font-extrabold tabular-nums text-ink">
              {formatPrice(costs.total, costs.currency)}
            </span>
          </InfoCardRow>
        </>
      )}
    </InfoCardBody>
  </InfoCard>
);

export default CostCategoryDonutCard;
